export const getShopsGroupingByCustomer = (listShop) => {
	let customerShopList = [];

	listShop.forEach((shopInfo) => {
		let customerIndex = customerShopList.findIndex((customerShopInfo) => (
			customerShopInfo.customerId === shopInfo.customerId
		));

		if (customerIndex >= 0) {
			customerShopList[customerIndex].shops.push(shopInfo);
		} else {
			customerShopList.push({
				customerId: shopInfo.customerId,
				customerName: shopInfo.customerName,
				shops: [shopInfo]
		})
		}
	});

	return customerShopList;
}